import React from "react";

const Section = props => {
  return (
    <div>
      <div
        className={`section section-${props.type}`}
        style={{ paddingTop: "10px", paddingBottom: "10px" }}
      >
        <div className="container">
          <h1 className="m-b-0 text-center">{props.title}</h1>
          {props.children}
        </div>
      </div>
    </div>
  );
};

export default Section;

// Section Classes
// .section-default
// .section-understated
// .section-primary
// .section-standout
// .section-inverted
